// extracted by mini-css-extract-plugin
module.exports = {"component":"FilterBox_component__Ll2eH"};